export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10288.d9e8cbf3.jpg";